<template>
  <div class="sticky-add-to-bag">
    <Button full-width @click="scrollToCta">
      Add to bag |
      {{ $filters.toCurrency(price.amount, price.currencyCode, 0) }}
      <template v-if="isOnSale">
        <span class="onsale">{{
          $filters.toCurrency(
            originalPrice.amount,
            originalPrice.currencyCode,
            0
          )
        }}</span>
      </template>
    </Button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Button from "@/components/Button.vue";

export default {
  name: "StickyAddToBag",
  components: {
    Button,
  },
  computed: {
    ...mapGetters("product", ["price", "originalPrice", "isOnSale"]),
  },
  methods: {
    scrollToCta() {
      const cta = document.querySelector('[data-testid="add-to-bag"]');
      cta.scrollIntoView({ behavior: "smooth", block: "center" });
    },
  },
};
</script>

<style lang="scss" scoped>
.sticky-add-to-bag {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 20px;
  z-index: 3;
}

.onsale {
  text-decoration: line-through;
}
</style>
